import { Text as Paragraph } from '@/components/Typography';

export const SuperTextElement = ({ text, tag }: { text: string; tag?: 'sup' | 'span' | 'p' }) => {
  return (
    <Paragraph className="top-0 intro-super-text" tag={tag ?? 'div'} type="lead">
      {text}
    </Paragraph>
  );
};
